import axiosInstance from '../lib/axios';

/**
 * Portal-side read access to the admin-defined hierarchy master.
 * Level labels come from template names; node options are RBAC-scoped by the
 * backend — nothing about specific levels ("Section", …) exists in this code.
 */

export interface HierarchyTemplate {
  id: number;
  template_key: string;
  name: string;
  parent_template_id: number | null;
  depth: number;
}

export interface HierarchyNode {
  id: number;
  parent_node_id: number | null;
  label: string;
  data: Record<string, unknown>;
  template: { id: number; template_key: string; name: string } | null;
}

export interface LookupTemplate {
  id: number;
  template_key: string;
  name: string;
}

export const hierarchyService = {
  getTemplates: () => axiosInstance.get('/hierarchy/templates'),

  /** Admin-created value masters (non-hierarchy templates, e.g. "File Category"). */
  getLookupTemplates: () => axiosInstance.get('/hierarchy/lookup-templates'),

  /** Active values (nodes) of one lookup template. */
  getTemplateNodes: (templateKey: string) =>
    axiosInstance.get('/hierarchy/template-nodes', { params: { template_key: templateKey } }),

  /**
   * template_id → options for one hierarchy level (accessible nodes +
   * ancestors of accessible subtrees for navigation), optionally under a
   * parent node. Without template_id: legacy cascade (entry points/children).
   */
  getNodes: (
    params: {
      template_id?: number;
      parent_node_id?: number | null;
      permission?: 'view' | 'upload';
    } = {}
  ) =>
    axiosInstance.get('/hierarchy/nodes', {
      params: {
        ...(params.template_id != null ? { template_id: params.template_id } : {}),
        ...(params.parent_node_id != null ? { parent_node_id: params.parent_node_id } : {}),
        ...(params.permission ? { permission: params.permission } : {}),
      },
    }),
};

export default hierarchyService;
